import { Button, Flex } from "@chakra-ui/react";
import { EmptyState } from "src/components/EmptyState";
import { ConditionalTooltip } from "src/components/Layout/ConditionalTooltip";
import { WithUserPermissions } from "src/components/Permissions/WithUserPermissions";
import EmptyWalletSvg from "src/images/empty-wallet.svg?react";

export interface Props {
  onCreatePayment: () => void;
  isPaymentConfigured: boolean;
}

export const Empty: React.FC<Props> = ({
  onCreatePayment,
  isPaymentConfigured,
}: Props) => {
  return (
    <Flex
      width="100%"
      height="100%"
      alignItems="center"
      justifyContent="center"
      flexGrow="1"
    >
      <EmptyState heading="No payments set up" Svg={EmptyWalletSvg}>
        <ConditionalTooltip
          showTooltip={!isPaymentConfigured}
          label="Complete payment setup before creating a new payment."
        >
          <WithUserPermissions permissions={["payments:create"]}>
            <Button
              variant="outline"
              colorScheme="gray"
              onClick={() => onCreatePayment()}
              isDisabled={!isPaymentConfigured}
            >
              Create new payment
            </Button>
          </WithUserPermissions>
        </ConditionalTooltip>
      </EmptyState>
    </Flex>
  );
};
